import {
  Heading,
  Stack,
} from '@chakra-ui/react';

import CourseCard from '../components/courseCard/CourseCard';
import Course1Image from '../assets/images/course-images/Course1.jpg';
import Course2Image from '../assets/images/course-images/Course2.jpg';
import Course3Image from '../assets/images/course-images/Course3.jpg';

const education = [
  {
    name: 'How to be an ally for Women in Tech',
    info: 'In this course, you’ll learn more about what it means to be an ally and what characteristics an ally embodies. Then, you’ll learn about five ally roles you can take on the next time you spot injustice.',
    image: Course1Image,
    link: 'https://rise.articulate.com/share/yO0pJLH8Pl4P1XACZP_o6dhKh7VD3_kF#/',
    duration: '25 minutes',
    completed: false,
  },
  {
    name: 'Having Uncomfortable Conversations',
    info: 'Uncomfortable Conversations at the Intersection of Black and White America, author Zachary Wood walks learners through a nine-step process for having difficult conversations about controversial issues.',
    image: Course2Image,
    link: 'https://rise.articulate.com/share/yO0pJLH8Pl4P1XACZP_o6dhKh7VD3_kF#/',
    duration: '30 minutes',
    completed: true,
  },
  {
    name: 'Eliminating Sexual Harassment',
    info: 'In this course, you’ll learn what a respectful workplace looks like, how to recognize harassment and discrimination, and what laws are in place to safeguard the workplace.',
    image: Course3Image,
    link: 'https://rise.articulate.com/share/yO0pJLH8Pl4P1XACZP_o6dhKh7VD3_kF#/',
    duration: '45 minutes',
    completed: false,
  },
]

function Learn() {
  return (
    <div className="experiences-page page">
      <Heading
        mt={10} mb={4}
        color={'brand.main'}
        className='text-focus-in'
      >
        Learn
      </Heading>
      <Stack
          className="cards fade-in-bottom-1"
          direction={{ base: 'column', md: 'row' }}
          spacing={{ base: 10, md: 4, lg: 10 }}
        >
        {education.map((course) => (
          <CourseCard
            key={course.name}
            name={course.name}
            info={course.info}
            image={course.image}
            link={course.link}
            duration={course.duration}
            completed={course.completed}
          />
        ))}
      </Stack>
    </div>
  );
}

export default Learn;
